import { render, staticRenderFns } from "./mc-footer.vue?vue&type=template&id=165bc80c&scoped=true"
import script from "./mc-footer.vue?vue&type=script&lang=ts"
export * from "./mc-footer.vue?vue&type=script&lang=ts"
import style0 from "./mc-footer.vue?vue&type=style&index=0&id=165bc80c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165bc80c",
  null
  
)

export default component.exports